<template>
  <div class="notice-info-wrap">
    <div class="info-wrap">
      <div class="top-logo">
        <img :src="loginT" @click="gotoHome"/>
      </div>
      <!-- 详情头部 -->
      <div class="details_box">
        <!-- <img src="images/details_bg.png" /> -->
        <div class="top_bg">
          <div class="left_box">
            <p class="title">关于“{{content.title}}”的{{cgfs}}公告<span class="link-span" @click="showOrder">{{content.orderCode}}</span></p>
            <p class="name listp" style="height: 15px">
              <span class="leftspan">项目名称：</span>
              <span class="rightspan">{{content.title}}</span>
            </p>
            <p class="name listp" style="height: 15px">
              <span class="leftspan">发布时间：</span>
              <span class="rightspan">{{content.createTime}}</span>
            </p>
            <p class="xz listp" style="height: 15px;">
              <span class="leftspan">开标时间：</span>
              <span class="rightspan">{{content.bjEndTime}}</span>
            </p>
            <p class="cg listp" style="height: 15px;">
              <span class="leftspan">采购方式：</span>
              <span class="rightspan">{{cgfs}}</span>
            </p>
            <p class="zb listp" style="height: 15px;">
              <span class="leftspan">招标单位：</span>
              <span class="rightspan">{{content.unitName}}</span>
<!--              <span class="rightspan">联系人：xxx</span>-->
<!--              <span class="rightspan">联系方式：xxxxxxxxx-->
<!--								<template v-if="projectInfo.openContactType == 1">-->
<!--									{{projectInfo.contactPhone}}-->
<!--								</template>-->
<!--								<template v-if="projectInfo.openContactType == 2">-->
<!--									报价后公开-->
<!--								</template>-->
<!--								<template v-if="projectInfo.openContactType == 3">-->
<!--									不公开-->
<!--								</template>-->
<!--							</span>-->
            </p>
          </div>
          <div class="right_box" style="padding-top:20px">
<!--            <div v-if="[5,6,8].includes(projectInfo.procurementStatus)" class="cannot">-->
<!--              <p class="sign ">项目已结束</p>-->
<!--              &lt;!&ndash; <a class="sign" @click="signHandle">查看详情</a> &ndash;&gt;-->
<!--            </div>-->
<!--            <div class="can">-->
<!--&lt;!&ndash;              <p class="sign" @click="signHandle">报名/接受邀请</p>&ndash;&gt;-->
<!--              <el-button type="primary"> 报名/接受邀请</el-button>-->
            <el-button type="primary" v-if="this.state==='1'" @click="promptEdit()"> 报名/接受邀请</el-button>
            <p class="words" v-if="this.state==='1'">
              <span>距报名结束：</span>
              <span>{{this.countDown}}</span>
            </p>
            <el-button type="info" v-if="this.state==='0'" disabled>项目已结束</el-button>
<!--            </div>-->
<!--            <div v-else-if="diffDate == '-'" class="cannot">-->
<!--              <p class="sign">报名已截止</p>-->
<!--              &lt;!&ndash; <a class="sign" @click="signHandle">查看详情</a> &ndash;&gt;-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-wrap" v-loading="loading">
         <div class="datail-title">关于“{{content.title}}”的{{cgfs}}公告<span class="link-span" @click="showOrder">{{content.orderCode}}</span></div>
        <div class="datail-title">{{content.title}}</div>
        <div class="time-bar" v-show="content.createTime">
          <div class="time-info">
            <span>发布日期：{{content.createTime}}</span>
            <span>发布单位：分宜县数字产业投资发展有限公司</span>
          </div>
        </div>

          <div class="artucle-info" v-html="content.remark"></div>
<!--        <div class="artucle-info">-->
<!--          <div class="info-a">-->
<!--            致：各位供应商-->
<!--          </div>-->
<!--          <div class="info-b">-->
<!--            我公司需求以下项目/服务,请贵公司收到采购单后,请按我公司模板于{{content.bjJzTime}}前将报价信息在本平台进行填报与提交，我方将择期开展价格、交付周期、交付质量的综合评审及谈价，确定采购供应商。-->
<!--          </div>-->
<!--          <div class="info-b">注:请各供应商仔细阅读以下要求并遵照执行:</div>-->
<!--          <div class="info-b">1.在要求时间内进行报价并提交,过期视为无效报价，对曾经有过供货;若非特殊原因,虚高报价,一经发现,我公司将停止后期对贵司询价，请各单位予以重视。</div>-->
<!--          <div class="info-b">2.报价表格严格按要求顺序、项目进行填报，不能报价请进行标记说明。</div>-->
<!--          <div class="info-b">3.若有其他需要说明的情况,请在备注栏注明。</div>-->
<!--&lt;!&ndash;          <div class="info-b">详见采购询价单：<span class="link-span" @click="showOrder">{{content.orderCode}}</span></div>&ndash;&gt;-->
<!--          <div class="info-c">-->
<!--            <div>-->
<!--              <p>分宜数字投资发展有限公司</p>-->
<!--              <p>{{date}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import loginT from '../assets/login_logo1.png'
import {zbggAnnouncementById} from '../api/notice'
import {srmXjOrderRemarkList} from "@/api/srm/srmXjOrderDetail";
import moment from "moment/moment";
export default {
  props: {

  },
  data() {
    return {
      loginT,
      content:{},
      noticeId:'',
      date:'',
      state:'',
      countDown:'',
      cgfs:'',
    };
  },
  computed: {

  },
  created() {
    let route = this.$route;
    this.noticeId = route.params.id;  // 详情id
    this.getinfo()
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    getinfo(){
      let _this = this;
      this.loading = true;
      zbggAnnouncementById({id:this.noticeId}).then(({data:res})=>{
        _this.loading = false;
        if(res.code == 0){
          console.log(res)
          _this.content = res.data;
          this.content = res.data;
          if(_this.content.createTime){
            let dateArr = _this.content.createTime.split(' ')[0].split('-')
            _this.date = `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
          }
          let bjEndTime = Date.parse(new Date(_this.content.bjEndTime));
          bjEndTime = bjEndTime / 1000;
          console.log(bjEndTime);

          let bjNow = parseInt(new Date().getTime()/1000);
          console.log(bjNow);
          if(bjNow>bjEndTime){
            this.state='0'
          }else{
            setInterval(function() {
              _this.getCountDown()
            }, 1000);
            this.state='1'
          }
          if(_this.content.xjFs===1){
            this.cgfs = "公开招标"
          }else if(_this.content.xjFs===3){
            this.cgfs = "竞争性谈判采购"
          }else if(_this.content.xjFs===4){
            this.cgfs = "询价采购"
          }else if(_this.content.xjFs===5){
            this.cgfs = "竞争性磋商采购"
          }else if(_this.content.xjFs===7){
            this.cgfs = "变更"
          }else if(_this.content.xjFs===8){
            this.cgfs = "询价采购"
          }
        }
      })
    },
    showOrder(){
      this.$router.push({path: `/srmXjOrderDetail/srmXjOrderDetail?hId=${this.content.orderId}&show=false`});
    },
    promptEdit(){
      this.$warn('请登录后报名！')
      setTimeout(function() {
        window.open(`/login`,'_self')
      }, 1000);

    },
    getCountDown() {
      let text = null;
      let info = this.content;
      if (info.bjEndTime && (info.orderState == 2 || info.gysOrderState == 3)) {
        let diff = moment(info.bjEndTime).unix() - moment().unix();
        if (diff <= 0) {
          text = '0天0时0分'
        } else {
          text = this.timeStamp(diff)
        }
      }
      this.countDown = text
    },
    timeStamp(second_time) {
      var time = parseInt(second_time) + "秒";
      if (parseInt(second_time) > 60) {
        var second = parseInt(second_time) % 60;
        var min = parseInt(second_time / 60);
        time = min + "分" + second + "秒";
        if (min > 60) {
          min = parseInt(second_time / 60) % 60;
          var hour = parseInt(parseInt(second_time / 60) / 60);
          time = hour + "小时" + min + "分" + second + "秒";

          if (hour > 24) {
            hour = parseInt(parseInt(second_time / 60) / 60) % 24;
            var day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
            time = day + "天" + hour + "小时" + min + "分" + second + "秒";
          }
        }
      }
      return time;
    },
    gotoHome(){
      this.$router.push({path: `/login`});
    },
  },
  components: {

  },
};
</script>

<style lang="scss">
.notice-info-wrap{
  .link-span{
    cursor: pointer;
    color: #1989fa;
  }
  width: 100%;
  min-height: 100vh;
  background: #F6F9FD;
  .info-wrap{
    width: 1240px;
    margin: 0 auto;
  }
  .top-logo{
    width: 100%;
    height: 40px;
    padding: 20px 0;
    text-align: left;
    img{
      height: 40px;
    }
  }
  .content-wrap{
    margin-top: 250px;
    width: calc(100% - 40px);
    padding: 20px;
    background: #fff;
    min-height: calc(100vh - 140px);
    .datail-title{
      width: 100%;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #535353;
    }
    .time-bar{
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: 20px;
      div{
        padding-top: 10px;
        border-top:1px solid #e0e0e0 ;
        font-size: 12px;
        color: #535353;
        span{
          margin: 0 10px;
        }
      }
    }
    .artucle-info{
      width: calc(100% - 200px);
      padding: 0 100px;
      margin-bottom: 50px;
      font-size: 14px;
      .info-a{
        color: #666;
        line-height: 50px;
      }
      .info-b{
        width: 100%;
        line-height: 30px;
        text-indent: 2em;
        /* font-size: 12px; */
        color: #333;
      }
      .info-c{
        margin-top: 100px;
        overflow: hidden;
        color: #666;
        div{
          text-align: center;
          float:right;
        }
      }
    }
  }

  .details_box{
    width: 1240px;
    margin: 0 auto;
    position: relative;

    .top_bg {
      background-image: url(../assets/details_bg.png);
      position: absolute;
      width: 100%;
      top: 0;
      padding: 25px 20px 5px 20px;
      box-sizing: border-box;
      display: block;
      background-repeat: round;

      .left_box {
        width: 935px;
        float: left;
        margin-left: 10px;
        .title {
          color: #111111;
          font-size: 20px;
          margin-bottom: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .listp {
          margin-bottom: 15px;

          span {
            color: #111111;
            font-size: 14px;
            float: left;
          }

          .leftspan {
            display: inline-block;
            width: 70px;
            vertical-align: top;
          }

          .rightspan {
            display: inline-block;
            width: 820px;
            vertical-align: top;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
          }
        }

        .xz .rightspan {
          display: inline-block;
          width: 820px;
          vertical-align: top;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 2;
        }

        .zb .rightspan {
          width: unset;
          margin-right: 60px;
        }
      }

      .right_box {
        width: 220px;
        float: right;
        right: 0;
        /* padding-left: 20px; */
        box-sizing: border-box;
        text-align: center;

        .cannot p{
          margin: 20px 0 0 40px;
          width: 150px;
          height: 50px;
          background-color: #999999;
          text-align: center;
          line-height: 50px;
          color: #FFFFFF;
          font-size: 16px;
          cursor: pointer;
        }
        .can{
          .sign {
            margin: 45px 0 0 40px;
            margin-bottom: 10px;
            width: 150px;
            height: 50px;
            background-color: #F8931F;
            text-align: center;
            line-height: 50px;
            color: #FFFFFF;
            font-size: 16px;
            cursor: pointer;
          }

        }
        .words{
          font-size: 14px;
          padding-top:30px;
          color: #dd6161;
        }
      }
    }
  }

}

</style>
